/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import swal from 'sweetalert2';
window.Swal = swal;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

Vue.component('landing-page', require('./components/frontend/landingPage.vue').default);
Vue.component('register', require('./components/frontend/registerUser.vue').default);
Vue.component('view-comment', require('./components/frontend/viewComment.vue').default);
Vue.component('tab-menu', require('./components/frontend/tabMenu.vue').default);
Vue.component('directory-view', require('./components/frontend/directoryView.vue').default);
Vue.component('dictionary-view', require('./components/frontend/dictionaryView.vue').default);
Vue.component('about-us', require('./components/frontend/aboutUs.vue').default);
Vue.component('bookmark-view-list', require('./components/frontend/bookmarkViewList.vue').default);
Vue.component('bookmark-view-post', require('./components/frontend/bookmarkViewPost.vue').default);
Vue.component('attachment', require('./components/frontend/attachment.vue').default);
Vue.component('share-media', require('./components/frontend/shareMedia.vue').default);
Vue.component('tab-attachment', require('./components/frontend/tabAttachment.vue').default);

Vue.component('post-create', require('./components/backend/posts/postCreate.vue').default);
Vue.component('post-create', require('./components/backend/posts/postCreate.vue').default);
Vue.component('post-edit', require('./components/backend/posts/postEdit.vue').default);
Vue.component('post-view-graph', require('./components/backend/posts/postViewGraph.vue').default);
Vue.component('post-view-button', require('./components/backend/posts/postViewButton.vue').default);
Vue.component('post-view-attachment', require('./components/backend/posts/postViewAttachment.vue').default);

Vue.component('comment-remark-button', require('./components/backend/comments/remarkButton.vue').default);
Vue.component('comment-remark-modal', require('./components/backend/comments/remarkModal.vue').default);

Vue.component('category-edit', require('./components/backend/categories/categoryEdit.vue').default);
Vue.component('category-create', require('./components/backend/categories/categoryCreate.vue').default);

Vue.component('dashboard', require('./components/backend/Dashboard.vue').default);

Vue.component('profile', require('./components/backend/Profile.vue').default);

Vue.component('user-create', require('./components/backend/users/userCreate.vue').default);
Vue.component('user-edit', require('./components/backend/users/userEdit.vue').default);


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
});
